import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import rehypeRaw from 'rehype-raw';
import ReactMarkdown from 'react-markdown';
import { Link } from 'site-modules/shared/components/link/link';
import { getCoreUrl } from 'site-modules/shared/utils/core-link-constructor';
import { isNew } from 'site-modules/shared/utils/publication-states';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { rehypeAnimatedChunks } from 'site-modules/personalized-search/utils/rehype-animated-chunks';

import './verdict.scss';

export function Verdict({ creativeId, componentParams, onRendered = noop, hidden = false, vehicle = undefined }) {
  const ref = useRef();

  const { show, verdictText } = componentParams;

  useEffect(() => {
    onRendered();
  }, [onRendered]);

  if (!show || !verdictText || !vehicle) return null;

  const { make, model, year, pubStates } = vehicle;

  return (
    <div className="verdict mt-1_5 mb-2" data-tracking-parent={creativeId} ref={ref}>
      <div className="pos-r">
        <div className="hidden-text">
          <div className="mb-0_5">{verdictText}</div>
        </div>
        {!hidden && (
          <div className="pos-a top-0 left-0 right-0 bottom-0">
            <div className="mb-0_5">
              <ReactMarkdown rehypePlugins={[rehypeRaw, rehypeAnimatedChunks]}>{verdictText}</ReactMarkdown>
            </div>
          </div>
        )}
      </div>
      <Link
        to={getCoreUrl({ makeSlug: make.slug, modelSlug: model.slug, year }, !isNew(pubStates))}
        data-tracking-id="view_review"
        data-tracking-value="read full review"
      >
        <span className="me-0_25 text-underline">Read full review</span>
        <i className="icon-arrow-right3 size-12" aria-hidden />
      </Link>
    </div>
  );
}

Verdict.propTypes = {
  creativeId: PropTypes.string.isRequired,
  componentParams: PropTypes.shape({
    show: PropTypes.bool,
    verdictText: PropTypes.string,
  }).isRequired,
  onRendered: PropTypes.func,
  vehicle: VehicleEntities.Vehicle,
  hidden: PropTypes.bool,
};
